import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CadastroProduct from '../services/productService';

const initialState = {
  error: false,
  success: false,
  loading: false,
  nfFiscal: [],
};

export const postEntradaNfProductThunk = createAsyncThunk(
  'entrada/postEntradaNfProduct',
  async (data, thunkAPI) => {
    const response = await CadastroProduct.postEntradaNfProduct(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const getEntradaNfProductThunk = createAsyncThunk(
  'entrada/getEntradaNfProduct',
  async (_, thunkAPI) => {
    const response = await CadastroProduct.getEntradaNfProduct();
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);

export const entradaProdutoSlice = createSlice({
  name: 'entrada',
  initialState,
  reducers: {
    resetOut: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postEntradaNfProductThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postEntradaNfProductThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.productos = action.payload;
      })
      .addCase(postEntradaNfProductThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getEntradaNfProductThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getEntradaNfProductThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = false;
        state.nfFiscal = action.payload;
      })
      .addCase(getEntradaNfProductThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
      });
  },
});

export const { resetOut } = entradaProdutoSlice.actions;
export default entradaProdutoSlice.reducer;
